var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgInfoBubble = function SvgInfoBubble(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "-1 -1 24 24",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.736 15.54h-.904V8.802a.778.778 0 00-.778-.779c-.01 0-.021.003-.032.003s-.021-.003-.033-.003H9.838a.778.778 0 100 1.556h.437v5.957H9.37a.778.778 0 100 1.557H12.736a.778.778 0 100-1.555zM10.895 6.671a.947.947 0 100-1.893.947.947 0 000 1.893z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 0C4.934 0 0 4.934 0 11c0 1.78.433 3.538 1.254 5.104l-.632 4.26a.779.779 0 00.889.883l4.134-.637A10.99 10.99 0 0011 22c6.066 0 11-4.934 11-11S17.066 0 11 0zm0 20.444a9.425 9.425 0 01-4.807-1.314.78.78 0 00-.515-.1l-3.362.518.515-3.472a.775.775 0 00-.09-.493A9.444 9.444 0 011.557 11c0-5.207 4.237-9.444 9.444-9.444 5.207 0 9.444 4.237 9.444 9.444 0 5.207-4.236 9.444-9.444 9.444z"
  })));
};

export default SvgInfoBubble;